const blackBox = () => {
  return new Promise((resolve) => {
    setTimeout(
      () =>
        resolve(
          window.IGLOO && window.IGLOO.getBlackbox
            ? window.IGLOO.getBlackbox()
            : {}
        ),
      2000
    );
  });
};

export default blackBox;
